import SEO from '../components/SEO';

function PrivacyPolicy() {
  return (
    <div className="page-privacy">
      <SEO title="Privacy Policy" description="Read the Anthroper privacy policy. Learn how we handle your data and protect your privacy." path="/privacy-policy" />
      <div className="container content-page">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: March 1, 2026</p>

        <section>
          <h2>Introduction</h2>
          <p>Anthroper ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information when you visit our website (the "Site").</p>
        </section>

        <section>
          <h2>Data Processing</h2>
          <p>All text and data you enter into our tools is processed entirely within your web browser using client-side JavaScript. Your data is never transmitted to our servers, stored in any database, or shared with any third party. Once you close or refresh the page, any data you entered is permanently gone.</p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <h3>Automatically Collected Information</h3>
          <p>When you visit our Site, we may automatically collect certain information, including:</p>
          <ul>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Referring website</li>
            <li>Pages visited and time spent on each page</li>
            <li>Approximate geographic location (country/region level only)</li>
          </ul>
          <h3>Information You Provide</h3>
          <p>If you contact us through our contact form, we collect the name, email address, and message content you provide. This information is used solely to respond to your inquiry.</p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>Our Site uses cookies to enhance your browsing experience:</p>
          <ul>
            <li>Essential cookies required for the Site to function properly (such as your theme preference).</li>
            <li>Analytics cookies to understand visitor behavior and improve our content.</li>
            <li>Advertising cookies used by Google AdSense to display relevant advertisements.</li>
          </ul>
          <p>You can control cookie preferences through your browser settings.</p>
        </section>

        <section>
          <h2>Third-Party Advertising</h2>
          <p>We use Google AdSense to display advertisements on our Site. Google may use cookies to serve ads based on your prior visits. You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>.</p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>Our Site is not directed at children under the age of 13. We do not knowingly collect personal information from children.</p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date.</p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:akshay.personal.business@gmail.com">akshay.personal.business@gmail.com</a> or through our <a href="/contact">Contact page</a>.</p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
